module.exports = __webpack_public_path__ + "static/fetch-ruffcut-helga-066bca7a042cb8e0376ebd1fd302c992.mp4";